import React, { useContext, useRef, useState } from 'react'
import { CircularProgress, ClickAwayListener, Grow, IconButton, MenuItem, MenuList, Paper, Popper } from '@mui/material'
// import DownloadIconV2 from 'src/common/icons/downloadIconV2'
import DownloadIcon from 'src/common/icons/downloadIcon'
import { CSVIcon, PdfIcon } from 'src/pages/security-assistant/fileIcons'
import reportsService from 'src/services/reports.service'
import { SnackBarContext } from 'src/App'

function extractFilename(contentDisposition) {
  const filenameStarMatch = contentDisposition.match(/filename\*=(?:UTF-8|utf-8)''([^;]+)/i)
  if (filenameStarMatch && filenameStarMatch[1]) {
    return decodeURIComponent(filenameStarMatch[1])
  }

  const filenameMatch = contentDisposition.match(/filename="?([^";]+)"?/i)
  if (filenameMatch && filenameMatch[1]) {
    const filename = filenameMatch[1]
    if (filename.startsWith('=?UTF-8?Q?') || filename.startsWith('=?utf-8?q?')) {
      return filename.replace(/^=\?UTF-8\?Q\?(.+)\?=$/i, (_, encoded) => {
        return encoded.replace(/_/g, ' ').replace(/=([0-9A-F]{2})/g, (_, hex) => String.fromCharCode(parseInt(hex, 16)))
      })
    }
    return filename
  }

  return null
}

export const REPORT_PAGES = {
  SIMULATION_CAMPAIGNS: 'simulationCampaigns',
  SIMULATION_CAMPAIGNS_OVERVIEW: 'simulationCampaignsOverview',
  BREACHES: 'breaches',
  USERS: 'users',
  GROUPS: 'groups',
  COMPANIES: 'companies',
  WORKFLOWS: 'workflows',
  WORKFLOWS_BY_ID: 'workflowsRepo',
  WORKFLOWSLOGS: 'workflowsLogs',
  THREATS: 'threats',
  TRAINING: 'trainings',
  TRAINING_BY_ID: 'trainingById'
}

const reportDownloadFunctionMapper = type => {
  switch (type) {
    case REPORT_PAGES.SIMULATION_CAMPAIGNS:
      return reportsService.getSimulationCampaignsReport
    case REPORT_PAGES.SIMULATION_CAMPAIGNS_OVERVIEW:
      return reportsService.getSimulationCampaignsOverviewReport
    case REPORT_PAGES.BREACHES:
      return reportsService.getBreachesReport
    case REPORT_PAGES.USERS:
      return reportsService.getUsersReport
    case REPORT_PAGES.GROUPS:
      return reportsService.getGroupsReport
    case REPORT_PAGES.COMPANIES:
      return reportsService.getCompaniesReport
    case REPORT_PAGES.WORKFLOWS:
      return reportsService.getWorkflowsReport
    case REPORT_PAGES.WORKFLOWS_BY_ID:
      return reportsService.getWorkflowsReportById
    case REPORT_PAGES.WORKFLOWSLOGS:
      return reportsService.getWorkflowsLogsReport
    case REPORT_PAGES.THREATS:
      return reportsService.getThreatsReport
    case REPORT_PAGES.TRAINING:
      return reportsService.getTrainingPackagesReport
    case REPORT_PAGES.TRAINING_BY_ID:
      return reportsService.getTrainingPackagesReportById

    default:
      break
  }
}

export function GetReportButton({ page, id }) {
  const [openImportMenu, setOpenImportMenu] = useState(false)
  const [loading, setLoading] = useState(false)
  const anchorRefButton = useRef(null)

  const { setErrorMessage } = useContext(SnackBarContext)

  const handleDownload = type => {
    setOpenImportMenu(false)
    setLoading(true)
    reportDownloadFunctionMapper(page)(type, id)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', extractFilename(response.headers['content-disposition']))
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      })
      .catch(e => {
        console.error(e)
        setErrorMessage('Something went wrong')
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <div style={{ position: 'relative' }}>
      {loading ? (
        <div
          style={{
            marginRight: '15px',
            marginLeft: '15px',
            padding: '8px'
          }}
        >
          <CircularProgress
            sx={{
              '& svg': {
                color: '#6123FF'
              }
            }}
            size='24px'
          />
        </div>
      ) : (
        <IconButton
          ref={anchorRefButton}
          variant={'text'}
          sx={{
            flexShrink: 0,
            textTransform: 'none',
            fontSize: '14px',
            color: '#1B1B26',
            fontWeight: 400,
            fontFamily: 'Plus Jakarta Sans',
            textDecoration: 'underline',
            marginRight: '15px',
            marginLeft: '15px'
          }}
          onClick={() => setOpenImportMenu(true)}
        >
          <DownloadIcon color='#6123FF' />
        </IconButton>
      )}

      <Popper
        sx={{
          zIndex: 1000
        }}
        open={openImportMenu}
        anchorEl={anchorRefButton.current}
        role={undefined}
        transition
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={() => setOpenImportMenu(false)}>
                <MenuList sx={{ width: '190px' }} id='split-button-menu' autoFocusItem>
                  <MenuItem
                    onClick={() => {
                      setOpenImportMenu(false)
                      handleDownload('csv')
                    }}
                  >
                    <CSVIcon />
                    Export as CSV
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setOpenImportMenu(false)
                      handleDownload('pdf')
                    }}
                  >
                    <div style={{ marginRight: 10 }}>
                      <PdfIcon />
                    </div>
                    Export as PDF
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  )
}
